// import api from './BaseService'
import api from './BaseService'
import pessoaService from './PessoaService'

async function efetuarLogin(loginPayload) {    
  const loginResult = await api.post(`login`, loginPayload)
  return loginResult
}

async function validarToken(token){
  const tokenResult = await api.post(`login/validarToken`,{token});
  return tokenResult;
}

const loginService = {
  efetuarLogin,
  validarToken
}
export default loginService


// WEBPACK FOOTER //
// ./src/services/LoginService.js